import { render, staticRenderFns } from "./MinusDisabled.vue?vue&type=template&id=ef0d4224&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef0d4224')) {
      api.createRecord('ef0d4224', component.options)
    } else {
      api.reload('ef0d4224', component.options)
    }
    module.hot.accept("./MinusDisabled.vue?vue&type=template&id=ef0d4224&", function () {
      api.rerender('ef0d4224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/MinusDisabled.vue"
export default component.exports